export function AccountSection() {
  return (
    <div className="space-y-4">
      <div className="bg-secondary aspect-video max-w-3xl rounded-xl flex items-center justify-center">
        <p className="text-muted-foreground">
          Account management and profile settings coming soon
        </p>
      </div>
    </div>
  )
}
